import { toast } from '@gitbook/spine-react';
import { HTTPError, HTTPStatusCode } from '@gitbook/util-debug';

export const duplicateSpaceError = (error: Error) => {
    if (error instanceof HTTPError && error.expose) {
        switch (error.statusCode) {
            case HTTPStatusCode.Locked:
                toast.error('Operation locked', error, {
                    description:
                        'An ongoing task is stopping the space from being duplicated. Wait a moment and try again.',
                });
                break;
            case HTTPStatusCode.Unauthorized:
                toast.error('Permissions required', error, {
                    description: 'The user account does not have permissions to duplicate a space.',
                });
                break;
            default:
                toast.error('Error while duplicating space.', error);
                break;
        }
    }
};
